(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-custom-old"] && !window.DesignMode) return;
  try {
    

      function sticky_relocate() {
      var window_top = $(window).scrollTop();
      var div_top = $('#sticky-anchor').offset().top + 100;
        console.log(div_top);
      if (window_top > div_top) {
        $('#sticky').addClass('stick');
       $('.announcement-bar-wrapper').addClass('announcement-bar-stick'); 
        
      } else {
        $('#sticky').removeClass('stick');
        $('.announcement-bar-wrapper').removeClass('announcement-bar-stick'); 
       
      }
    }

    $(function() {
      $(window).scroll(sticky_relocate);
      sticky_relocate();
    });

 
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-custom"] && !window.DesignMode) return;
  try {
    

      function sticky_relocate() {
      var window_top = $(window).scrollTop();
      var div_top = $('#sticky-anchor').offset().top + 100;
        console.log(div_top);
      if (window_top > div_top) {
        $('#sticky').addClass('stick');
       $('.announcement-bar-wrapper').addClass('announcement-bar-stick'); 
        
      } else {
        $('#sticky').removeClass('stick');
        $('.announcement-bar-wrapper').removeClass('announcement-bar-stick'); 
       
      }
    }

    $(function() {
      $(window).scroll(sticky_relocate);
      sticky_relocate();
    });

 
  


  } catch(e) { console.error(e); }
})();
})();
